import { PerpLimitOrder, PostPerpLegMarket, PostPerpsLimit } from "#/types/api";
import { type OptionMarketData } from "#/types/options";
import { type TransformedOrderbook } from "#/types/orderbook";
import { OptionLimitOrder, type Order } from "#/types/orders";

import { isOptionInstrument } from "./instrument.utils";

export const extractOrderSize = (order: Order): number => {
  if ("contracts" in order) return order.contracts ?? 0;

  return (order as PostPerpLegMarket | PostPerpsLimit).amount ?? NaN;
};

export const extractFilledOrderSize = (
  order: OptionLimitOrder | PerpLimitOrder,
): number => {
  if (isOptionInstrument(order.instrument_name)) return order.filled_amount;

  const perpOrder = order as PerpLimitOrder;
  return perpOrder.contracts !== undefined
    ? perpOrder.filled_contracts
    : perpOrder.filled_amount;
};

export const transformOptionOrderbook = (
  book?: OptionMarketData,
): TransformedOrderbook => {
  if (!book) return { sells: [], buys: [] };

  const sells = book.asks
    .map(([price, size]) => {
      return {
        price,
        size,
        total: size * price,
        iv: book.ask_iv,
      };
    })
    .reverse();
  const buys = book.bids.map(([price, size]) => {
    return {
      price,
      size,
      total: size * price,
      iv: book.bid_iv,
    };
  });

  return {
    sells,
    buys,
  };
};
